import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'calsoft-trial-exiped-message',
  templateUrl: './trial-exiped-message.component.html',
  styleUrls: ['./trial-exiped-message.component.scss']
})
export class TrialExipedMessageComponent implements OnInit, OnDestroy {

  trialExpiredMessage: any;
  private _destroy$ = new Subject<void>();

  @Input() type: any = 1;

  constructor(
    private subscriptionsService: SubscriptionsService
  ) {

  }

  ngOnInit() {
    this.subscriptionsService.trialExpiredMessage$
      .pipe(takeUntil(this._destroy$))
      .subscribe(msg => {
        this.trialExpiredMessage = msg;
      });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}

